<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return { setInterObj: null };
  },
  async created() {
    let paramId = "";
    let id = this.$route.query.id;
    if (id != undefined) {
      paramId = id;
    } else {
      await this.getdeviceId();
      let deviceId = await this.getdeviceId();
      paramId = deviceId;
    }
    this.$common
      .http({
        method: "get",
        url: `/api/queue/summary/board_url?id=${paramId}`
      })
      .then(res => {
        let view_url = res.data.data.view_url;
        window.location.replace(view_url);
      });
  },
  methods: {
    getdeviceId() {
      return new Promise(resolve => {
        let deviceId = "";
        this.setInterObj = window.setInterval(() => {
          try {
            console.log("获取设备id");
            /* eslint-disable no-undef */
            deviceId = api && api.deviceId;
          } catch (error) {
            console.warn(error);
          }
          if (deviceId.length > 0) {
            window.clearInterval(this.setInterObj);
            resolve(deviceId);
          }
        }, 1 * 1000);
      });
    }
  }
};
</script>
<style lang="less"></style>
